export enum ControlModes {
  MODE = 'mode',
  TYPE = 'type',
  DATA = 'data',
}
